var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1080_7330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7C14.76 7 17 9.24 17 12C17 12.645 16.87 13.26 16.645 13.825L19.57 16.75C21.08 15.49 22.27 13.86 23.005 12C21.27 7.61 17.005 4.5 12 4.5C10.6 4.5 9.26 4.75 8.015 5.2L10.175 7.355C10.74 7.135 11.355 7 12 7ZM2 4.275L4.28 6.555L4.735 7.01C3.085 8.3 1.78 10.015 1 12C2.73 16.39 7 19.5 12 19.5C13.55 19.5 15.03 19.2 16.385 18.655L16.81 19.08L19.725 22L21 20.73L3.275 3L2 4.275ZM7.53 9.8L9.075 11.345C9.03 11.56 9 11.775 9 12C9 13.655 10.345 15 12 15C12.225 15 12.44 14.97 12.65 14.925L14.195 16.47C13.53 16.8 12.79 17 12 17C9.24 17 7 14.76 7 12C7 11.21 7.2 10.47 7.53 9.8ZM11.835 9.015L14.985 12.165L15 12C15 10.345 13.655 9 12 9L11.835 9.015Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1080_7330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOff);
export default __webpack_public_path__ + "static/media/visibility-off.cabfac2a2b73fdba9029462744c20aee.svg";
export { ForwardRef as ReactComponent };